import { FIND_TABLE_ENTRIES_REQUEST, findTableEntriesSuccess, findTableEntriesFailure } from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export function findTableEntriesEpic(action$, store$, { TableRepository }) {
    return action$.pipe(
        ofType( FIND_TABLE_ENTRIES_REQUEST ),
        mergeMap(action => from(
          TableRepository.findAll(action.payload)
                .then(({ tableEntries, meta }) => findTableEntriesSuccess({ tableEntries, response: meta, request: action}))
                .catch(error => findTableEntriesFailure({ error, request: action })),
        )),
    );
}
